module.exports = __webpack_public_path__ + "static/media/burberry-my-burberry-women-big.c36a17e5.png";